<template>
    <button
        class="
                flex items-center px-6 py-2.5 uppercase
                rounded font-semibold text-xs text-black text-opacity-70
                focus:outline-none transition ease-in-out duration-150 hover:bg-opacity-80
            "
        :class="isDisabled ? 'border border-gray-300' : 'bg-yellow-400'"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        isDisabled: { type: Boolean, default: false }
    }
};
</script>
